import React from 'react'
import styled from 'styled-components'
import Modal from '../modal'

const NoteElement = styled.p`
  width: 16rem;
  font-weight: 200;
  font-size: 1.2rem !important;
  text-wrap: pretty;
`

const EditNoteButtonElement = styled.p`
  color: #2e8ab8;
  cursor: pointer;
`

function NotePreviewModal({ note, toggleEdit, onClose }) {
  return (
    <Modal title={<NoteElement>{note}</NoteElement>} onClose={onClose}>
      <EditNoteButtonElement onClick={toggleEdit}>
        Edit note
      </EditNoteButtonElement>
    </Modal>
  )
}

export default NotePreviewModal
